// FLAGS: none
// Maps session-type slugs to the English labels analytics reports on, passing unknown slugs through.
export const SESSION_TYPE_LABELS: Record<string, string> = {
  general: "General",
  "physical-wellbeing": "Physical Health Coaching",
  "financial-wellbeing": "Financial Coaching",
  mindfulness: "Mindfulness",
  "confidential-advisor": "Confidential Advisor",
};

export function getSessionTypeLabel(sessionType: string): string {
  return SESSION_TYPE_LABELS[sessionType] ?? sessionType;
}
